<template>
  <v-data-iterator
    :items="policies.data"
    :page.sync="page"
    :items-per-page.sync="size"
    :server-items-length="policies.meta.pagination.total"
    :footer-props="{ itemsPerPageOptions }"
  >
    <template v-slot:default="slot">
      <im-policy-card v-for="(policy, index) in slot.items"
        :policy="policy"
        :key="index"
        @edit="$emit('edit', policy)"
      />
    </template>
  </v-data-iterator>
</template>


<script>

  export default {
    components: {
      'im-policy-card': () => import('@/components/PolicyCancellation/CancellationPolicyCard')
    },

    props: {
      policies: Object
    },

    data: () => ({
      page: 1,
      size: 10,
      itemsPerPageOptions: [10, 15, 30, 50]
    }),

    watch: {
      page: {
        handler () {
          this.$emit('list', {
            size: this.size,
            page: this.page
          })
        },
        immediate: false,
        deep: true
      },
      size: {
        handler () {
          this.$emit('list', {
            size: this.size,
            page: this.page})
        },
        immediate: false,
        deep: true
      },
    },
  }

</script>